import React, { useEffect, useState } from 'react'
import './teams-landing.styles.scss';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import GroupsList from './teams-list.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import TeamForm from './teams-form.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import TeamView from './team-view.component';

const TeamsLandingPage = ({
  gameData,
  gameElements,
  teamMembers,
  playerList,
  role
}) => {

  const membership = useSelector(state => state.userData.membership);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameData) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
        pageTitleEl.innerText = 'Manage Teams';
    }
  }, [gameData])
  
  useEffect(() => {
    if (!membership) return;
    checkMembership();
  }, [membership])

  useEffect(() => {
    if (!role) return;
    if (role !== 'owner' && role !== 'manager') {
      navigate(-1);
    }
  }, [role])

  function checkMembership() {
    const element = 'teams'
    const res = testMemberRestrictions({ 
      'gameData': gameData, 
      'membership': membership, 
      'element': element 
    })
    // console.log(res);

    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access Teams.`;
      }
      setShowUpgradeModal(message)
    }
  }

  return (
    <div className='teams-landing'>
      <div className='g-card teams-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className='g-space-1'></div>
        <div className='card-title'>
          <ImageContainer 
            src='/images/icons/groups.png' 
            className='head-icon' />
          Create and Edit Teams</div>
        <hr />
        <div className='teams-landing-content'>
          <Routes>
            <Route path='' element={
              <GroupsList playerList={playerList} />
            }></Route>
            <Route path='create' element={
              <TeamForm 
                gameData={gameData} 
                gameElements={gameElements} 
                playerList={playerList} />
            }></Route>
            <Route path=':teamPath' element={
              <TeamView 
                gameData={gameData}
                playerList={playerList}
                teamMembers={teamMembers}
              />
            }></Route>
            <Route path=':teamPath/edit' element={
              <TeamForm 
                gameData={gameData} 
                gameElements={gameElements} 
                playerList={playerList} />
            }></Route>
            <Route path="*" element={
              <Navigate replace to="/404" />
            } />
          </Routes>
        </div>
      </div>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default TeamsLandingPage